import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ContentLoader from 'react-content-loader'

export default class DetailLoader extends Component {
  static propTypes = {
    modulesCount: PropTypes.number,
    withProfilePicture: PropTypes.bool,
    withHeavyForm: PropTypes.bool,
    withActionButton: PropTypes.bool,
    withLogo: PropTypes.bool
  }

  static defaultProps = {
    modulesCount: 1,
    withActionButton: false,
    withProfilePicture: true,
    withLogo: false,
    withHeavyForm: false
  }

  render() {
    const {
      modulesCount,
      withProfilePicture,
      withHeavyForm,
      withActionButton,
      withLogo
    } = this.props

    const canvasHeight = modulesCount > 2 || withHeavyForm || withLogo
      ? 200
      : 150
    const inputX = withProfilePicture && !withLogo ? 80 : 0
    const inputYBase = withLogo ? 30 : 0
    let inputWidth = withProfilePicture ? 110 : 190

    if (withLogo) {
      inputWidth = 95
    }

    return (
      <div>
        {withActionButton &&
          <ContentLoader
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
            primaryOpacity={0.9}
            secondaryOpacity={0.9}
            style={null}
            height={13}
          >
            <rect x="350" y={0} rx="1" ry="1" width={50} height="8" />
          </ContentLoader>}
        <ContentLoader
          uniquekey="detail-loader-key"
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
          primaryOpacity={0.9}
          secondaryOpacity={0.9}
          style={null}
          height={canvasHeight}
        >

          {/* Pure SVG */}
          {withProfilePicture &&
            !withLogo &&
            <rect x="0" y="0" rx="1" ry="1" width="70" height="70" />}
          {withLogo &&
            <rect x="0" y="0" rx="1" ry="1" width="50" height="20" />}
          <rect
            x={inputX}
            y={`${inputYBase + 0}`}
            rx="1"
            ry="1"
            width={inputWidth}
            height="8"
          />
          <rect
            x={inputX}
            y={`${inputYBase + 20}`}
            rx="1"
            ry="1"
            width={inputWidth}
            height="8"
          />
          <rect
            x={inputX}
            y={`${inputYBase + 40}`}
            rx="1"
            ry="1"
            width={inputWidth}
            height="8"
          />
          <rect
            x={inputX}
            y={`${inputYBase + 60}`}
            rx="1"
            ry="1"
            width={inputWidth}
            height="8"
          />

          {!withLogo &&
            <rect
              x="0"
              y={`${inputYBase + 85}`}
              rx="1"
              ry="1"
              width="140"
              height="8"
            />}
          {!withLogo &&
            <rect
              x="150"
              y={`${inputYBase + 85}`}
              rx="1"
              ry="1"
              width="40"
              height="8"
            />}
          {!withLogo &&
            <rect
              x="0"
              y={`${inputYBase + 105}`}
              rx="1"
              ry="1"
              width="140"
              height="8"
            />}

          {(withHeavyForm || withLogo) &&
            <rect x="0" y="125" rx="1" ry="1" width="90" height="8" />}
          {(withHeavyForm || withLogo) &&
            <rect x="100" y="125" rx="1" ry="1" width="90" height="8" />}
          {(withHeavyForm || withLogo) &&
            <rect x="0" y="145" rx="1" ry="1" width="90" height="8" />}
          {(withHeavyForm || withLogo) &&
            <rect x="100" y="145" rx="1" ry="1" width="90" height="8" />}

          {modulesCount >= 1 &&
            <rect x="210" y="0" rx="1" ry="1" width="190" height="50" />}
          {modulesCount >= 2 &&
            <rect x="210" y="60" rx="1" ry="1" width="190" height="50" />}
          {modulesCount >= 3 &&
            <rect x="210" y="120" rx="1" ry="1" width="190" height="50" />}
        </ContentLoader>
      </div>
    )
  }
}
